import TileWMS from 'ol/source/TileWMS';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import Group from 'ol/layer/Group';
import GeoJSON from 'ol/format/GeoJSON.js';
import { Vector as VectorSource } from 'ol/source.js';
import { Vector as VectorLayer } from 'ol/layer.js';

///---------------linijka-----------------

export const source = new VectorSource();

const vector = new VectorLayer({
  source: source,
  displayInLayerSwitcher: false,
  style: {
    'fill-color': 'rgba(255, 255, 255, 0.2)',
    'stroke-color': '#ffcc33',
    'stroke-width': 2,
    'circle-radius': 7,
    'circle-fill-color': '#ffcc33',
  },
  layerName: 'vector'
});


//Extent

var wroclaw_extent = [1891056.6688629973, 6634866.7007701285, 1902790.4809153082, 6645301.44570074];
var warszawa_extent = [2325654.112952754, 6829879.959448638, 2354272.3682971145, 6854216.233018171];
var torun_extent = [2065847.0701204129, 6979928.052938929, 2077185.998656427, 6991637.946420874];
var tarnow_extent = [2331644.5700382777, 6445330.06380434, 2343257.6144212186, 6451938.130149868];
var siedlce_extent = [2473801.2501218338, 6825499.227439133, 2485788.958204347, 6835547.4440246485];
var rzeszow_extent = [2445788.320915108, 6448660.256616964, 2453977.8638173416, 6457421.367474078];
var radom_extent = [2348038.3654131996, 6687347.763105882, 2360662.055613735, 6695440.266053836];
var poznan_extent = [1877311.097339744, 6866464.721692664, 1892299.6793942645, 6878695.20789327];
var lodz_extent = [2151726.5974692507, 6736548.765469215, 2176022.1338275596, 6777071.118892917];
var lublin_extent = [2508338.3526151567, 6658167.0471456265, 2517004.5978800524, 6669835.2734503215];
var krakow_extent = [2212939.5315384357, 6446020.896054933, 2226982.8722117376, 6463954.960125238];
var kielce_extent = [2290447.6438059667, 6592948.030079599, 2303038.190664115, 6602236.278303993];
var katowice_extent = [2113190.7652246184, 6487662.55167769, 2124576.283861739, 6495509.1806617975];
var jaslo_extent = [2383762.0052214693, 6396926.71026648, 2397236.9231684227, 6409412.142424818];
var inowroclaw_extent = [2026307.7568149827, 6943399.199583084, 2036819.3403155073, 6950069.765970141];
var grudziadz_extent = [2084164.0063928894, 7070375.706075313, 2092238.8762300543, 7079555.558100721];
var gdansk_extent = [2069625.667382177, 7232189.255718066, 2081589.598706026, 7250000.441084893];
var czestochowa_extent = [2122843.1198181673, 6580954.080564622, 2133625.017767686, 6590870.381581478];
var bydgoszcz_extent = [1997689.0624584185, 7002170.854759689, 2010036.7561663345, 7010763.17354138];
var bialystok_extent = [2571101.1916520753875375, 7001415.9465610180050135, 2583557.3204755992628634, 7011858.3240038193762302];
var ukvme_extent = [1372754.3880530973, 5780292.453044169, 3821489.285177462, 8180009.0210157195];
var kdwr_extent = [1929279.3106249874, 6446099.743804963, 3042333.510721354, 7914635.371909083];
var kdr_gb_extent = [1484064.1322775844, 6065259.436462955, 3153638.4082078924, 7708844.505857798];
var kdr_extent = [649300.9499926413, 5982833.902132139, 2597078.71107039, 7558100.04227917];
var m25k_extent = [1558265.8395252659, 6342844.739291834, 2745485.8395252656, 7538214.739291834];
var textor_extent = [2066627.274164477, 6841905.514838818, 2710109.277484889, 7467785.454685503];
var gilly_extent = [1656827.9951888199429959, 6458620.3213150082156062, 2434090.3125056321732700, 7117696.4054006300866604];
var schroetter_extent = [1681507.3430747332, 6858941.92292049, 2556894.8439899227, 7577972.338746325];
var kummersberg_extent = [2073265.5883935662, 6264224.553262652, 2676902.20638954, 6575407.948382095];
var chrzanowski_extent = [1324895.0087654856, 5750526.26446042, 4261777.707765106, 8008604.962801416];
var gaul_extent = [1683141.2845012100879103, 6709130.1668563140556216, 1932518.2419683916959912, 6981461.0902313701808453];
var wig500k_extent = [1502813.125709193, 6274881.993338907, 2838647.0152284745, 7361893.302732942];
var wig300k_extent = [1595579.3680369216, 6274870.968790573, 2708774.275969658, 7362779.339171509];
var wig100k_extent = [1428378.13184701, 6064994.249715181, 3209489.984539359, 7558044.65608178];
var wig25k_extent = [1743772.534088552, 6303041.1130512245, 3042732.534088552, 7361866.1130512245];
var tkkp_extent = [1910731.7752000000327826, 6430155.7879669172689319, 2748916.6974000004120171, 7412092.0998999997973442];
var ahp_extent = [1649010.1492071698885411, 6275829.8578319428488612, 2676896.1077683675102890, 7349680.9213318098336458];
var reymann_extent = [1434029.7937346000690013, 6306301.8876584814861417, 2853627.1681993757374585, 7364489.8797003002837300];
var warszawaOKI_extent = [2332310.8616340449079871, 6835320.4745610337704420, 2345627.2974652498960495, 6850688.1840605083853006];
var warszawaNowy_extent = [2335732.2268547825515270, 6841895.2175341192632914, 2343237.1122601442039013, 6847795.9181218128651381];
var rauch_extent = [2337267.1474263588897884, 6841800.8314891224727035, 2345402.5544371674768627, 6851365.7001673532649875];
var lindley_extent = [2331388.2537273601628840, 6832543.7426134394481778, 2346603.0971444840542972, 6856849.1275746598839760];
var dwuwiorstowka_extent = [1973407.0335200214758515, 6190443.8091354481875896, 3175657.5340873757377267, 7558415.6560817826539278]
var krakowskie18w_extent = [2032972.7059406312182546, 6412791.5906958896666765, 2341027.2701209443621337, 6657693.9959212001413107];
var slask18w_extent = [1592282.1875139637850225, 6387821.1673362571746111, 2155123.9936346644535661, 6895754.4180549727752805];
var biecz_extent = [2364251.0980427339673042, 6397715.4784333622083068, 2368316.5945765506476164, 6400944.9748246036469936];
var bielsk_extent = [2580241.8818332529626787, 6938591.0223709717392921, 2585167.4572711647488177, 6942153.4453975008800626];
var brzesc_extent = [2102389.3321910006925464, 6908631.8241418646648526, 2107118.1266302010044456, 6911911.7631386211141944];
var chelmno_extent = [2049387.9422407133970410, 7046422.8161333734169602, 2054222.1895939041860402, 7049797.0672976393252611];
var czestochowaNowa_extent = [2125477.4122061128728092, 6586240.2561606038361788, 2129985.0920224869623780, 6589393.2783740442246199];
var dobrzyn_extent = [2149927.3088945997878909, 6913935.0707478849217296, 2154673.1003352841362357, 6917233.4860507994890213];
var dolsk_extent = [1897612.7942458204925060, 6795550.0006743399426341, 1902358.1316932984627783, 6798909.1134590022265911];
var drohiczyn_extent = [2519550.1225689491257071, 6869173.9894435591995716, 2524445.3879161509685218, 6873456.1192504595965147];
var elblag_extent = [2156975.0985704367049038, 7197994.3980846479535103, 2163998.0935700680129230, 7202991.7876218138262630];
var gdanskNowy_extent = [2072946.5222710876259953, 7230809.5856692362576723, 2080024.2645067269913852, 7240916.0015019364655018];
var gniezno_extent = [1956454.2918621106073260, 6894611.8347827373072505, 1963278.6688268501311541, 6899376.7722457675263286];
var inowroclawNowy_extent = [2031168.4171663427259773, 6943360.0339226350188255, 2035948.1435926922131330, 6946694.5251934416592121];
var kalisz_extent = [2011475.0267038540914655, 6753964.4422822492197156, 2018229.8919462147168815, 6758692.8773759845644236];
var koscian_extent = [1851398.8832069279160351, 6813459.2668870026245713, 1856174.2861568427179009, 6816850.7087793974205852];
var leczyca_extent = [2136272.4724793913774192, 6808928.1256450768560171, 2140657.6237059906125069, 6812403.4783738134428859];
var malbork_extent = [2116838.3770178174600005, 7173925.0798282027244568, 2123398.3681184486486018, 7178784.7535110041499138];
var mielnik_extent = [2562791.9120997991412878, 6858004.4231666149571538, 2567660.7055042786523700, 6861518.6894825240597129];
var mielnikKrzywczyckie_extent = [2562838.8652967587113380, 6857509.0935809276998043, 2567388.0032981876283884, 6861394.6276600537821651];
var wawel_extent = [2218948.8424064354039729, 6455344.6297497376799583, 2219739.1436691060662270, 6455967.4673266550526023];
var krakow1563_extent = [2218793.7368322764523327, 6455582.7047802200540900, 2220247.3527899235486984, 6457710.6695017246529460];
var krakowNowy_extent = [2215686.7365777282975614, 6452295.3245122404769063, 2226932.9024967025034130, 6460928.9471192695200443];
var NowySacz_extent = [2302522.8431729632429779, 6378962.0982481073588133, 2305860.9611777523532510, 6383274.6749425949528813];
var piotrkow_extent = [2191742.4770333906635642, 6692287.5819113301113248, 2195384.6800248464569449, 6694991.5702718812972307];
var pleszew_extent = [1978331.4485684428364038, 6779152.7477486925199628, 1983035.2817718342412263, 6782465.4835189785808325];
var plock_extent = [2188692.6546788895502687, 6897184.2065590051934123, 2194937.9363341131247580, 6900445.3393443580716848];
var poznanNowy_extent = [1882194.8080081504303962, 6870548.2528023580089211, 1891275.0372137264348567, 6877268.4568264223635197];
var rawa_extent = [2251869.3604680001735687, 6756112.3878657445311546, 2257367.1805885406211019, 6759145.9004885004833341];
var sandomierz_extent = [2419537.5573815940879285, 6562949.1751143354922533, 2425012.3475919393822551, 6566730.5059229927137494];
var sieradz_extent = [2084876.6345500436145812, 6725380.4658132279291749, 2089389.7172706325072795, 6728410.3788323644548655];
var siewierz_extent = [2140402.0677613629959524, 6525981.8376402854919434, 2144229.9203300876542926, 6529142.7635038644075394];
var wegrow_extent = [2449169.3481214572675526, 6870276.2094240505248308, 2454005.7093136096373200, 6873734.0664860615506768];
var wieliczka_extent = [2232081.7736612902954221, 6440996.0146306660026312, 2235729.9181947829201818, 6444657.9159335354343057];
var wielun_extent = [2066078.6679668121505529, 6658918.6264612218365073, 2069976.2939971291925758, 6661674.3731333985924721];
var wloclawek_extent = [2120939.6737603065557778, 6916700.9633884951472282, 2125064.2888911976478994, 6921395.9217403717339039];
var wschowa_extent = [1815516.9970029657706618, 6762854.9697071304544806, 1820271.7582801233511418, 6766245.6617140360176563];


// OSM
const osm = new TileLayer({
  title: "Mapa współczesna (OSM)",
  baseLayer: false,
  source: new OSM(),
  visible: true,
  infoTitle: 'Mapa współczesna (OpenStreetMap)',
  layerName: 'osm',
});

export const osm_magnify = new TileLayer({
  title: "Mapa współczesna (OSM)",
  baseLayer: false,
  source: new OSM(),
  visible: true,
  infoTitle: 'Mapa współczesna (OpenStreetMap)',
  layerName: 'osm',
});

//Add Layer

function addLayer(nazwa, title, infotitle, extent) {
  var name = nazwa
  return name = new TileLayer({
    source: new TileWMS({
      url: 'https://pastmaps.cenagis.edu.pl/geoserver/ihpan/wms/',
      params: { 'LAYERS': 'topp:' + nazwa + '_3857', 'TILED': true },
      serverType: 'geoserver',
      transition: 0,
    }),
    visible: false,
    permalink: nazwa,
    title: title,
    infoTitle: infotitle,
    plan: '',
    layerName: nazwa,
    extent: extent,
  });

}

function addLayerPlan(nazwa, title, infotitle, extent) {
  var name = nazwa
  return name = new TileLayer({
    source: new TileWMS({
      url: 'https://pastmaps.cenagis.edu.pl/geoserver/ihpan/wms/',
      params: { 'LAYERS': 'topp:' + nazwa + '_3857', 'TILED': true },
      serverType: 'geoserver',
      transition: 0,
    }),
    visible: false,
    permalink: nazwa,
    title: title,
    infoTitle: infotitle,
    plan: 'plan',
    layerName: nazwa,
    extent: extent,
  });
}

function addLayerPlan_XVIw(nazwa, title, infotitle, extent) {
  var name = nazwa
  return name = new TileLayer({
    source: new TileWMS({
      url: 'https://data.atlasfontium.pl/geoserver/wms',
      params: { 'LAYERS': 'geonode:' + nazwa, 'TILED': true, },
      serverType: 'geoserver',
      transition: 0,
    }),
    visible: false,
    permalink: nazwa,
    title: title,
    infoTitle: infotitle,
    plan: 'planXVIw',
    layerName: nazwa,
    extent: extent,
  });
}

function addLayer2180(nazwa, title, infotitle, extent) {
  var name = nazwa
  return name = new TileLayer({
    source: new TileWMS({
      url: 'https://pastmaps.cenagis.edu.pl/geoserver/ihpan/wms/',
      params: { 'LAYERS': 'topp:' + nazwa + '_2180', 'TILED': true },
      serverType: 'geoserver',
      transition: 0,
    }),
    visible: false,
    permalink: nazwa,
    title: title,
    infoTitle: infotitle,
    plan: '',
    layerName: nazwa,
    extent: extent,
  });

}

//Index
export const index_source = new VectorSource({
  format: new GeoJSON,
  url: function () {
    return ('https://data.atlasfontium.pl/geoserver/wfs?service=WFS&' +
      'version=1.0.0&request=GetFeature&typename=geonode%3Aindex_pastmaps&' +
      'outputFormat=json&srs=EPSG%3A3857&srsName=EPSG%3A3857')
  },
  serverType: 'geoserver',
  transition: 0,
})
export const index = new VectorLayer({
  source: index_source,
  displayInLayerSwitcher: false,
  title: 'Skorowidz',
  infoTitle: 'Skorowidz',
  layerName: 'skorowidz',
  visible: false,
  style: {
    'fill-color': 'rgba(15, 97, 164, 0.0)',
    'stroke-color': 'rgb(59, 104, 140)',
    'stroke-width': 1.3,
  }
})

//map set to magnify in ZoomBox
//Atlas historyczny Polski w XVIII w
export const slask18w_magnify = addLayer2180('slask18w', 'Śląsk w końcu XVIII wieku', 'Śląsk w końcu XVIII wieku ', slask18w_extent)
export const krakowskie18w_magnify = addLayer2180('krakowskie18w', 'Mapa województwa krakowskiego z doby Sejmu Czteroletniego (1788-1792)', 'Mapa województwa krakowskiego z doby Sejmu Czteroletniego (1788-1792)', krakowskie18w_extent)

//Atlas historyczny Polski. Mapy szczegółowe XVI w.
export const ahp_drogi_magnify = addLayer('ahp_drogi', 'Drogi w drugiej połowie XVI w.', 'Drogi w drugiej połowie XVI w.', ahp_extent)
export const ahp_wlasnosc_magnify = addLayer('ahp_wlasnosc', 'Rozmieszczenie własności w drugiej połowie XVI w.', 'Rozmieszczenie własności w drugiej połowie XVI w.', ahp_extent)
export const ahp_koscielne_magnify = addLayer('ahp_koscielne', 'Podziały kościelne w drugiej połowie XVI w.', 'Podziały kościelne w drugiej połowie XVI w.', ahp_extent)
export const ahp_ziemie_polskie_magnify = addLayer('ahp_ziemie_polskie', 'Ziemie polskie Korony w drugiej połowie XVI w.', 'Ziemie polskie Korony w drugiej połowie XVI w.', ahp_extent)

//Plany miast
export const wschowaNowy_magnify = addLayerPlan_XVIw('Wschowa_nowy', 'Plan Wschowy [AHP XVI w.]', 'Plan Wschowy [AHP XVI w.]', wschowa_extent)
export const wroclaw_magnify = addLayerPlan('wroclaw', 'Plan Wrocławia (1944)', 'Plan Wrocławia (1944)', wroclaw_extent)
export const wloclawekNowy_magnify = addLayerPlan_XVIw('Wloclawek_nowy', 'Plan Włocławka [AHP XVI w.]', 'Plan Włocławka [AHP XVI w.]', wloclawek_extent)
export const wielunNowy_magnify = addLayerPlan_XVIw('Wielun_nowy', 'Plan Wielunia [AHP XVI w.]', 'Plan Wielunia [AHP XVI w.]', wielun_extent)
export const wieliczkaNowy_magnify = addLayerPlan_XVIw('Wieliczka_nowy', 'Plan Wieliczki [AHP XVI w.]', 'Plan Wieliczki [AHP XVI w.]', wieliczka_extent)
export const wegrowNowy_magnify = addLayerPlan_XVIw('Wegrow_nowy', 'Plan Węgrowa [AHP XVI w.]', 'Plan Węgrowa [AHP XVI w.]', wegrow_extent)
export const torun_magnify = addLayerPlan('torun', 'Plan Torunia (1943)', 'Plan Torunia (1943)', torun_extent)
export const tarnow_magnify = addLayerPlan('tarnow', 'Plan Tarnowa (1943)', 'Plan Tarnowa (1943)', tarnow_extent)
export const siewierzNowy_magnify = addLayerPlan_XVIw('Siewierz_nowy', 'Plan Siewierza [AHP XVI w.]', 'Plan Siewierza [AHP XVI w.]', siewierz_extent)
export const sieradzNowy_magnify = addLayerPlan_XVIw('Sieradz_nowy', 'Plan Sieradza [AHP XVI w.]', 'Plan Sieradza [AHP XVI w.]', sieradz_extent)
export const siedlce_magnify = addLayerPlan('siedlce', 'Plan Siedlec (1943)', 'Plan Siedlec (1943)', siedlce_extent)
export const sandomierzNowy_magnify = addLayerPlan_XVIw('Sandomierz_nowy', 'Plan Sandomierza [AHP XVI w.]', 'Plan Sandomierza [AHP XVI w.]', sandomierz_extent)
export const rzeszow_magnify = addLayerPlan('rzeszow', 'Plan Rzeszowa (1943)', 'Plan Rzeszowa (1943)', rzeszow_extent)
export const rawaNowy_magnify = addLayerPlan_XVIw('Rawa_nowy', 'Plan Rawy [AHP XVI w.]', 'Plan Rawy [AHP XVI w.]', rawa_extent)
export const radom_magnify = addLayerPlan('radom', 'Plan Radomia (1943)', 'Plan Radomia (1943)', radom_extent)
export const poznanNowy_magnify = addLayerPlan_XVIw('Poznan_nowy', 'Plan Poznania [AHP XVI w.]', 'Plan Poznania [AHP XVI w.]', poznanNowy_extent)
export const poznan_magnify = addLayerPlan('poznan', 'Plan Poznania (1943)', 'Plan Poznania (1943)', poznan_extent)
export const plockNowy_magnify = addLayerPlan_XVIw('Plock_nowy', 'Plan Płocka [AHP XVI w.]', 'Plan Płocka [AHP XVI w.]', plock_extent)
export const pleszewNowy_magnify = addLayerPlan_XVIw('Pleszew_nowy', 'Plan Pleszewa [AHP XVI w.]', 'Plan Pleszewa [AHP XVI w.]', pleszew_extent)
export const piotrkowNowy_magnify = addLayerPlan_XVIw('Piotrkow_nowy', 'Plan Piotrkowa [AHP XVI w.]', 'Plan Piotrkowa [AHP XVI w.]', piotrkow_extent)
export const nowySaczNowy_magnify = addLayerPlan_XVIw('NowySacz_nowy', 'Plan Nowego Sącza [AHP XVI w.]', 'Plan Nowego Sącza [AHP XVI w.]', NowySacz_extent)
export const mielKrzywNowy_magnify = addLayerPlan_XVIw('MielnikKrzywczyce_nowy', 'Plan Mielnika i przedmieścia Krzywczyckiego [AHP XVI w.]', 'Plan Mielnika i przedmieścia Krzywczyckiego [AHP XVI w.]', mielnikKrzywczyckie_extent)
export const mielnikNowy_magnify = addLayerPlan_XVIw('Mielnik_nowy', 'Plan Mielnika [AHP XVI w.]', 'Plan Mielnika [AHP XVI w.]', mielnik_extent)
export const malborkNowy_magnify = addLayerPlan_XVIw('Malbork_nowy', 'Plan Malborka [AHP XVI w.]', 'Plan Malborka [AHP XVI w.]', malbork_extent)
export const leczycaNowa_magnify = addLayerPlan_XVIw('Leczyca_nowy', 'Plan Łęczycy [AHP XVI w.]', 'Plan Łęczycy [AHP XVI w.]', leczyca_extent)
export const lodz_magnify = addLayerPlan('lodz', 'Plan Łodzi (1943)', 'Plan Łodzi (1943)', lodz_extent)
export const lublin_magnify = addLayerPlan('lublin', 'Plan Lublina (1943)', 'Plan Lublina (1943)', lublin_extent)
export const krakow_magnify = addLayerPlan('krakow', 'Plan Krakowa (1943)', 'Plan Krakowa (1943)', krakow_extent)
export const krakowNowy_magnify = addLayerPlan_XVIw('Krakow_nowy', 'Plan Krakowa [AHP XVI w.]', 'Plan Krakowa [AHP XVI w.]', krakowNowy_extent)
export const krakow1563Nowy_magnify = addLayerPlan_XVIw('Krakow1563_nowy', 'Plan Krakowa w 1598 r. [AHP XVI w.]', 'Plan Krakowa w 1598 r. [AHP XVI w.]', krakow1563_extent)
export const wawelNowy_magnify = addLayerPlan_XVIw('Wawel_nowy', 'Plan Wawelu [AHP XVI w.]', 'Plan Wawelu [AHP XVI w.]', wawel_extent)
export const koscianNowy_magnify = addLayerPlan_XVIw('Koscian_nowy', 'Plan Kościana [AHP XVI w.]', 'Plan Kościana [AHP XVI w.]', koscian_extent)
export const kielce_magnify = addLayerPlan('kielce', 'Plan Kielc (1943)', 'Plan Kielc (1943)', kielce_extent)
export const katowice_magnify = addLayerPlan('katowice', 'Plan Katowic (1943)', 'Plan Katowic (1943)', katowice_extent)
export const kaliszNowy_magnify = addLayerPlan_XVIw('Kalisz_nowy', 'Plan Kalisza [AHP XVI w.]', 'Plan Kalisza [AHP XVI w.]', kalisz_extent)
export const jaslo_magnify = addLayerPlan('jaslo', 'Plan Jasła (1943)', 'Plan Jasła (1943)', jaslo_extent)
export const inowroclawNowy_magnify = addLayerPlan_XVIw('Inowroclaw_nowy', 'Plan Inowrocławia [AHP XVI w.]', 'Plan Inowrocławia [AHP XVI w.]', inowroclawNowy_extent)
export const inowroclaw_magnify = addLayerPlan('inowroclaw', 'Plan Inowrocławia (1943)', 'Plan Inowrocławia (1943)', inowroclaw_extent)
export const grudziadz_magnify = addLayerPlan('grudziadz', 'Plan Grudziądza (1943)', 'Plan Grudziądza (1943)', grudziadz_extent)
export const gnieznoNowy_magnify = addLayerPlan_XVIw('Gniezno_nowy', 'Plan Gniezna [AHP XVI w.]', 'Plan Gniezna [AHP XVI w.]', gniezno_extent)
export const gdanskNowy_magnify = addLayerPlan_XVIw('Gdansk_nowy', 'Plan Gdańska [AHP XVI w.]', 'Plan Gdańska [AHP XVI w.]', gdanskNowy_extent)
export const gdansk_magnify = addLayerPlan('gdansk', 'Plan Gdańska (1944)', 'Plan Gdańska (1944)', gdansk_extent)
export const elblagNowy_magnify = addLayerPlan_XVIw('Elblag_nowy', 'Plan Elbląga [AHP XVI w.]', 'Plan Elbląga [AHP XVI w.]', elblag_extent)
export const drohiczynNowy_magnify = addLayerPlan_XVIw('Drohiczyn_nowy', 'Plan Drohiczyna [AHP XVI w.]', 'Plan Drohiczyna [AHP XVI w.]', drohiczyn_extent)
export const dolskNowy_magnify = addLayerPlan_XVIw('Dolsk_nowy', 'Plan Dolska [AHP XVI w.]', 'Plan Dolska [AHP XVI w.]', dolsk_extent)
export const dobrzynNowy_magnify = addLayerPlan_XVIw('Dobrzyn_nowy', 'Plan Dobrzynia [AHP XVI w.]', 'Plan Dobrzynia [AHP XVI w.]', dobrzyn_extent)
export const czestochowaNowa_magnify = addLayerPlan_XVIw('Czestochowa_nowa', 'Plan Częstochowy [AHP XVI w.]', 'Plan Częstochowy [AHP XVI w.]', czestochowaNowa_extent)
export const czestochowa_magnify = addLayerPlan('czestochowa', 'Plan Częstochowy (1943)', 'Plan Częstochowy (1943)', czestochowa_extent)
export const chelmnoNowy_magnify = addLayerPlan_XVIw('Chelmno_nowy', 'Plan Chełmna [AHP XVI w.]', 'Chełmno [AHP XVI w.]', chelmno_extent)
export const bydgoszcz_magnify = addLayerPlan('bydgoszcz', 'Plan Bydgoszczy (1943)', 'Plan Bydgoszczy (1943)', bydgoszcz_extent)
export const brzescNowy_magnify = addLayerPlan_XVIw('Brzesc_nowy', 'Plan Brześcia [AHP XVI w.]', 'Brześć [AHP XVI w.]', brzesc_extent)
export const bielskNowy_magnify = addLayerPlan_XVIw('Bielsk_nowy', 'Plan Bielska [AHP XVI w.]', 'Bielsk [AHP XVI w.]', bielsk_extent)
export const bieczNowy_magnify = addLayerPlan_XVIw('Biecz_nowy', 'Plan Biecza [AHP XVI w.]', 'Biecz [AHP XVI w.]', biecz_extent)
export const bialystok_magnify = addLayerPlan('bialystok', 'Plan Białegostoku (1943)', 'Plan Białegostoku (1943)', bialystok_extent)

//Plany Warszawy
export const warszawa_magnify = addLayerPlan('warszawa', 'Plan Warszawy (1944)', 'Plan Warszawy (1944)', warszawa_extent)
export const lindley_magnify = addLayer('lindley', 'Warszawa - mapa Lindleyów (1897-1901)', 'Warszawa - mapa Lindleyów (1897-1901)', lindley_extent)
export const warszawaOKI_magnify = addLayer2180('warszawaOKI', 'Plan miasta stołecznego Warszawy (1822)', 'Plan miasta stołecznego Warszawy (1822)', warszawaOKI_extent)
export const rauch_magnify = addLayer2180('rauch', 'Original Plan der Vorstadt Praga (1796)', 'Original Plan der Vorstadt Praga (1796)', rauch_extent)
export const warszawaNowy_magnify = addLayerPlan_XVIw('Warszawa_nowy', 'Warszawa [AHP XVI w.]', 'Warszawa [AHP XVI w.]', warszawaNowy_extent)

//Mapy rosyjskie
export const dwuwiorstowka_magnify = addLayer('dwuwiorstowka', 'Dwuwiorstówka 1:84 000 (1908-1936)', 'Dwuwiorstówka 1:84 000 (1908-1936)', dwuwiorstowka_extent)

//Mapy pruskie i niemieckie
export const ukvme_magnify = addLayer('ukvme', 'Mitteleuropa 1:300 000 (ok. 1900)', 'Mitteleuropa 1:300 000 (ok. 1900)', ukvme_extent)
export const kdwr_magnify = addLayer('kdwr', 'Westlichen Russlands 1:100 000 (1914-1921)', 'Westlichen Russlands 1:100 000 (1914-1921)', kdwr_extent)
export const kdr_gb_magnify = addLayer('kdr_gb', 'Deutschen Reiches 1:100 000 (ok. 1944)', 'Deutschen Reiches 1:100 000 (ok. 1944)', kdr_gb_extent)
export const kdr_magnify = addLayer('kdr', 'Deutschen Reiches 1:100 000 (ok. 1900)', 'Deutschen Reiches 1:100 000 (ok. 1900)', kdr_extent)
export const m25k_magnify = addLayer('m25k', 'Messtichblätter 1:25 000 (1870-1945)', 'Messtichblätter 1:25 000 (1870-1945)', m25k_extent)
export const reymann_magnify = addLayer('reymann', "Mapa Reymanna 1:200 000 (druga połowa XIX w.)", "Reymann's Special-Karte von Central Europa, 1:200 000 (druga połowa XIX w.)", reymann_extent)
export const textor_magnify = addLayer('textor', 'Mapa Textora-Sotzmanna 1:150 000 (1806-1808)', 'Mapa Textora-Sotzmanna 1:150 000 (1806-1808)', textor_extent)
export const gilly_magnify = addLayer('gilly', "Mapa Gilly'ego 1:150 000 (1802-1803)", "Mapa Gilly'ego 1:150 000 (1802-1803)", gilly_extent)
export const schroetter_magnify = addLayer('schroetter', 'Mapa Schroettera 1:150 000 (1796-1802)', 'Mapa Schroettera 1:150 000 (1796-1802)', schroetter_extent)

//Mapy austriackie
export const kummersberg_magnify = addLayer('kummersberg', 'Mapa Kummersberga 1:115 200 (1855)', 'Mapa Kummersberga 1:115 200 (1855)', kummersberg_extent)

//Mapy polskie
export const chrzanowski_magnify = addLayer('chrzanowski', 'Karta Dawnej Polski 1:300 000 (1859)', 'Karta Dawnej Polski 1:300 000 (1859)', chrzanowski_extent)
export const TKKP_126k_magnify = addLayer('TKKP_126k', 'Mapa Kwatermistrzowstwa 1:126 000 (1839-1843)', 'Mapa Kwatermistrzostwa 1:126 000 (1839-1843)', tkkp_extent)
export const gaul_magnify = addLayer('gaul', 'Mapa Gaula/Raczyńskiego 1:125 000 (1807-1812)', 'Mapa Gaula/Raczyńskiego 1:125 000 (1807-1812)', gaul_extent)

//Mapy WIG (1919-1949)
export const wig500k_magnify = addLayer('wig500k', 'Mapa Polski i Krajów Ościennych 1:500 000 (1947)', 'Mapa Polski i Krajów Ościennych 1:500 000 (1947)', wig500k_extent)
export const wig500k1939_magnify = addLayer('wig500k1939', 'Mapa Polski i Krajów Ościennych 1:500 000 (1939)', 'Mapa Polski i Krajów Ościennych 1:500 000 (1939)', wig500k_extent)
export const wig300k_magnify = addLayer('wig300k', 'Mapa operacyjna 1:300 000', 'Mapa operacyjna 1:300 000', wig300k_extent)
export const wig100k_magnify = addLayer('wig100k', 'Mapa taktyczna 1:100 000', 'Mapa taktyczna 1:100 000', wig100k_extent)
export const wig25k_magnify = addLayer('wig25k', 'Mapa szczegółowa 1:25 000', 'Mapa szczegółowa 1:25 000', wig25k_extent)




// list of layers
export var layers = [
  osm,
  new Group({
    title: 'Mapy historyczne',
    openInLayerSwitcher: false,
    visible: false,
    permalink: "historyczne",
    infoTitle: 'Mapy historyczne',
    layerName: 'historyczne',
    layers: [
      new Group({
        title: 'Atlas historyczny Polski w XVIII w',
        openInLayerSwitcher: false,
        visible: false,
        permalink: "ahp18w",
        infoTitle: 'Atlas historyczny Polski w XVIII w',
        layerName: 'ahp18w',
        layers: [
          addLayer2180('slask18w', 'Śląsk w końcu XVIII wieku', 'Śląsk w końcu XVIII wieku ', slask18w_extent),
          addLayer2180('krakowskie18w', 'Woj. krakowskie z doby Sejmu Czteroletniego (1788-1792)', 'Mapa województwa krakowskiego z doby Sejmu Czteroletniego (1788-1792)', krakowskie18w_extent)
        ]
      }),
      new Group({
        title: 'Atlas historyczny Polski. Mapy szczegółowe XVI w.',
        openInLayerSwitcher: false,
        visible: false,
        permalink: "ahp",
        infoTitle: 'Atlas historyczny Polski. Mapy szczegółowe XVI w.',
        layerName: 'ahp',
        layers: [
          addLayer('ahp_drogi', 'Drogi w drugiej połowie XVI w.', 'Drogi w drugiej połowie XVI w.', ahp_extent),
          addLayer('ahp_wlasnosc', 'Rozmieszczenie własności w drugiej połowie XVI w.', 'Rozmieszczenie własności w drugiej połowie XVI w.', ahp_extent),
          addLayer('ahp_koscielne', 'Podziały kościelne w drugiej połowie XVI w.', 'Podziały kościelne w drugiej połowie XVI w.', ahp_extent),
          addLayer('ahp_ziemie_polskie', 'Ziemie polskie Korony w drugiej połowie XVI w.', 'Ziemie polskie Korony w drugiej połowie XVI w.', ahp_extent),
        ]
      }),

    ]
  }),
  new Group({
    title: 'Plany miast',
    openInLayerSwitcher: false,
    visible: false,
    infoTitle: 'Plany miast',
    layerName: 'plany',
    permalink: "plany_miast",
    layers: [
      addLayerPlan_XVIw('Wschowa_nowy', 'Plan Wschowy [AHP XVI w.]', 'Plan Wschowy [AHP XVI w.]', wschowa_extent),
      addLayerPlan('wroclaw', 'Plan Wrocławia (1944)', 'Plan Wrocławia (1944)', wroclaw_extent),
      addLayerPlan_XVIw('Wloclawek_nowy', 'Plan Włocławka [AHP XVI w.]', 'Plan Włocławka [AHP XVI w.]', wloclawek_extent),
      addLayerPlan_XVIw('Wielun_nowy', 'Plan Wielunia [AHP XVI w.]', 'Plan Wielunia [AHP XVI w.]', wielun_extent),
      addLayerPlan_XVIw('Wieliczka_nowy', 'Plan Wieliczki [AHP XVI w.]', 'Plan Wieliczki [AHP XVI w.]', wieliczka_extent),
      addLayerPlan_XVIw('Wegrow_nowy', 'Plan Węgrowa [AHP XVI w.]', 'Plan Węgrowa [AHP XVI w.]', wegrow_extent),
      addLayerPlan('torun', 'Plan Torunia (1943)', 'Plan Torunia (1943)', torun_extent),
      addLayerPlan('tarnow', 'Plan Tarnowa (1943)', 'Plan Tarnowa (1943)', tarnow_extent),
      addLayerPlan_XVIw('Siewierz_nowy', 'Plan Siewierza [AHP XVI w.]', 'Plan Siewierza [AHP XVI w.]', siewierz_extent),
      addLayerPlan_XVIw('Sieradz_nowy', 'Plan Sieradza [AHP XVI w.]', 'Plan Sieradza [AHP XVI w.]', sieradz_extent),
      addLayerPlan('siedlce', 'Plan Siedlec (1943)', 'Plan Siedlec (1943)', siedlce_extent),
      addLayerPlan_XVIw('Sandomierz_nowy', 'Plan Sandomierza [AHP XVI w.]', 'Plan Sandomierza [AHP XVI w.]', sandomierz_extent),
      addLayerPlan('rzeszow', 'Plan Rzeszowa (1943)', 'Plan Rzeszowa (1943)', rzeszow_extent),
      addLayerPlan_XVIw('Rawa_nowy', 'Plan Rawy [AHP XVI w.]', 'Plan Rawy [AHP XVI w.]', rawa_extent),
      addLayerPlan('radom', 'Plan Radomia (1943)', 'Plan Radomia (1943)', radom_extent),
      new Group({
        title: 'Plany Poznania',
        openInLayerSwitcher: false,
        visible: false,
        infoTitle: 'Plany Poznania',
        layerName: 'plany_poznania',
        permalink: "plany_poznania",
        layers:
          [
            addLayerPlan('poznan', 'Plan Poznania (1943)', 'Plan Poznania (1943)', poznan_extent),
            addLayerPlan_XVIw('Poznan_nowy', 'Plan Poznania [AHP XVI w.]', 'Plan Poznania [AHP XVI w.]', poznanNowy_extent),
          ]
      }),
      addLayerPlan_XVIw('Plock_nowy', 'Plan Płocka [AHP XVI w.]', 'Plan Płocka [AHP XVI w.]', plock_extent),
      addLayerPlan_XVIw('Pleszew_nowy', 'Plan Pleszewa [AHP XVI w.]', 'Plan Pleszewa [AHP XVI w.]', pleszew_extent),
      addLayerPlan_XVIw('Piotrkow_nowy', 'Plan Piotrkowa [AHP XVI w.]', 'Plan Piotrkowa [AHP XVI w.]', piotrkow_extent),
      addLayerPlan_XVIw('NowySacz_nowy', 'Plan Nowego Sącza [AHP XVI w.]', 'Plan Nowego Sącza [AHP XVI w.]', NowySacz_extent),
      new Group({
        title: 'Plany Mielnika',
        openInLayerSwitcher: false,
        visible: false,
        infoTitle: 'Plany Mielnika',
        layerName: 'plany_mielnika',
        permalink: "plany_mielnika",
        layers:
          [
            addLayerPlan_XVIw('MielnikKrzywczyce_nowy', 'Plan Mielnika i przedmieścia Krzywczyckiego [AHP XVI w.]', 'Plan Mielnika i przedmieścia Krzywczyckiego [AHP XVI w.]', mielnikKrzywczyckie_extent),
            addLayerPlan_XVIw('Mielnik_nowy', 'Plan Mielnika [AHP XVI w.]', 'Plan Mielnika [AHP XVI w.]', mielnik_extent),
          ]
      }),
      addLayerPlan_XVIw('Malbork_nowy', 'Plan Malborka [AHP XVI w.]', 'Plan Malborka [AHP XVI w.]', malbork_extent),
      addLayerPlan('lodz', 'Plan Łodzi (1943)', 'Plan Łodzi (1943)', lodz_extent),
      addLayerPlan_XVIw('Leczyca_nowy', 'Plan Łęczycy [AHP XVI w.]', 'Plan Łęczycy [AHP XVI w.]', leczyca_extent),
      addLayerPlan('lublin', 'Plan Lublina (1943)', 'Plan Lublina (1943)', lublin_extent),
      new Group({
        title: 'Plany Krakowa',
        openInLayerSwitcher: false,
        visible: false,
        infoTitle: 'Plany Krakowa',
        layerName: 'plany_krakowa',
        permalink: "plany_krakowa",
        layers:
          [
            addLayerPlan('krakow', 'Plan Krakowa (1943)', 'Plan Krakowa (1943)', krakow_extent),
            addLayerPlan_XVIw('Krakow_nowy', 'Plan Krakowa [AHP XVI w.]', 'Plan Krakowa [AHP XVI w.]', krakowNowy_extent),
            addLayerPlan_XVIw('Krakow1563_nowy', 'Plan Krakowa w 1598 r. [AHP XVI w.]', 'Plan Krakowa w 1598 roku [AHP XVI w.]', krakow1563_extent),
            addLayerPlan_XVIw('Wawel_nowy', 'Plan Wawelu [AHP XVI w.]', 'Plan Wawelu [AHP XVI w.]', wawel_extent),
          ]
      }),
      addLayerPlan_XVIw('Koscian_nowy', 'Plan Kościana [AHP XVI w.]', 'Plan Kościana [AHP XVI w.]', koscian_extent),
      addLayerPlan('kielce', 'Plan Kielc (1943)', 'Plan Kielc (1943)', kielce_extent),
      addLayerPlan('katowice', 'Plan Katowic (1943)', 'Plan Katowic (1943)', katowice_extent),
      addLayerPlan_XVIw('Kalisz_nowy', 'Plan Kalisza [AHP XVI w.]', 'Plan Kalisza [AHP XVI w.]', kalisz_extent),
      addLayerPlan('jaslo', 'Plan Jasła (1943)', 'Plan Jasła (1943)', jaslo_extent),
      new Group({
        title: 'Plany Inowrocławia',
        openInLayerSwitcher: false,
        visible: false,
        infoTitle: 'Plany Inowrocławia',
        layerName: 'plany_inowroclawia',
        permalink: "plany_inowroclawia",
        layers:
          [
            addLayerPlan('inowroclaw', 'Plan Inowrocławia (1943)', 'Plan Inowrocławia (1943)', inowroclaw_extent),
            addLayerPlan_XVIw('Inowroclaw_nowy', 'Plan Inowrocławia [AHP XVI w.]', 'Plan Inowrocławia [AHP XVI w.]', inowroclawNowy_extent),
          ]
      }),
      addLayerPlan('grudziadz', 'Plan Grudziądza (1943)', 'Plan Grudziądza (1943)', grudziadz_extent),
      addLayerPlan_XVIw('Gniezno_nowy', 'Plan Gniezna [AHP XVI w.]', 'Plan Gniezna [AHP XVI w.]', gniezno_extent),
      new Group({
        title: 'Plany Gdańska',
        openInLayerSwitcher: false,
        visible: false,
        infoTitle: 'Plany Gdańska',
        layerName: 'plany_gdanska',
        permalink: "plany_gdanska",
        layers:
          [
            addLayerPlan('gdansk', 'Plan Gdańska (1944)', 'Plan Gdańska (1944)', gdansk_extent),
            addLayerPlan_XVIw('Gdansk_nowy', 'Plan Gdańska [AHP XVI w.]', 'Plan Gdańska [AHP XVI w.]', gdanskNowy_extent),
          ]
      }),
      addLayerPlan_XVIw('Elblag_nowy', 'Plan Elbląga [AHP XVI w.]', 'Plan Elbląga [AHP XVI w.]', elblag_extent),
      addLayerPlan_XVIw('Drohiczyn_nowy', 'Plan Drohiczyna [AHP XVI w.]', 'Plan Drohiczyna [AHP XVI w.]', drohiczyn_extent),
      addLayerPlan_XVIw('Dolsk_nowy', 'Plan Dolska [AHP XVI w.]', 'Plan Dolska [AHP XVI w.]', dolsk_extent),
      addLayerPlan_XVIw('Dobrzyn_nowy', 'Plan Dobrzynia [AHP XVI w.]', 'Plan Dobrzynia [AHP XVI w.]', dobrzyn_extent),
      new Group({
        title: 'Plany Częstochowy',
        openInLayerSwitcher: false,
        visible: false,
        infoTitle: 'Plany Częstochowy',
        layerName: 'plany_czestochowy',
        permalink: "plany_czestochowy",
        layers:
          [
            addLayerPlan('czestochowa', 'Plan Częstochowy (1943)', 'Plan Częstochowy (1943)', czestochowa_extent),
            addLayerPlan_XVIw('Czestochowa_nowa', 'Plan Częstochowy [AHP XVI w.]', 'Plan Częstochowy [AHP XVI w.]', czestochowaNowa_extent),
          ]
      }),
      addLayerPlan_XVIw('Chelmno_nowy', 'Plan Chełmna [AHP XVI w.]', 'Chełmno [AHP XVI w.]', chelmno_extent),
      addLayerPlan('bydgoszcz', 'Plan Bydgoszczy (1943)', 'Plan Bydgoszczy (1943)', bydgoszcz_extent),
      addLayerPlan_XVIw('Brzesc_nowy', 'Plan Brześcia [AHP XVI w.]', 'Brześć [AHP XVI w.]', brzesc_extent),
      addLayerPlan_XVIw('Bielsk_nowy', 'Plan Bielska [AHP XVI w.]', 'Bielsk [AHP XVI w.]', bielsk_extent),
      addLayerPlan_XVIw('Biecz_nowy', 'Plan Biecza [AHP XVI w.]', 'Biecz [AHP XVI w.]', biecz_extent),
      addLayerPlan('bialystok', 'Plan Białegostoku (1943)', 'Plan Białegostoku (1943)', bialystok_extent),
      new Group({
        title: 'Plany Warszawy',
        openInLayerSwitcher: false,
        visible: false,
        infoTitle: 'Plany Warszawy',
        layerName: 'plany_warszawy',
        permalink: "plany_warszawy",
        layers: [
          addLayerPlan('warszawa', 'Plan Warszawy (1944)', 'Plan Warszawy (1944)', warszawa_extent),
          addLayer('lindley', 'Warszawa - mapa Lindleyów (1897-1901)', 'Warszawa - mapa Lindleyów (1897-1901)', lindley_extent),
          addLayer2180('warszawaOKI', 'Plan miasta stołecznego Warszawy (1822)', 'Plan miasta stołecznego Warszawy (1822)', warszawaOKI_extent),
          addLayer2180('rauch', 'Original Plan der Vorstadt Praga (1796)', 'Original Plan der Vorstadt Praga (1796)', rauch_extent),
          addLayerPlan_XVIw('Warszawa_nowy', 'Warszawa [AHP XVI w.]', 'Warszawa [AHP XVI w.]', warszawaNowy_extent)
        ]
      }),
    ]
  }),
  new Group({
    title: 'Mapy rosyjskie',
    openInLayerSwitcher: false,
    visible: false,
    permalink: "rosyjskie",
    infoTitle: 'Mapy rosyjskie',
    layerName: 'rosyjskie',
    layers: [
      addLayer('dwuwiorstowka', 'Dwuwiorstówka 1:84 000 (1908-1936)', 'Dwuwiorstówka 1:84 000 (1908-1936)', dwuwiorstowka_extent),
    ]
  }),
  new Group({
    title: 'Mapy pruskie i niemieckie',
    openInLayerSwitcher: false,
    visible: false,
    permalink: "pruskie_niemieckie",
    infoTitle: 'Mapy pruskie i niemieckie',
    layerName: 'pruskie_niemieckie',
    layers: [
      addLayer('ukvme', 'Mitteleuropa 1:300 000 (ok. 1900)', 'Mitteleuropa 1:300 000 (ok. 1900)', ukvme_extent),
      addLayer('kdwr', 'Westlichen Russlands 1:100 000 (1914-1921)', 'Westlichen Russlands 1:100 000 (1914-1921)', kdwr_extent),
      addLayer('kdr_gb', 'Deutschen Reiches 1:100 000 (ok. 1944)', 'Deutschen Reiches 1:100 000 (ok. 1944)', kdr_gb_extent),
      addLayer('kdr', 'Deutschen Reiches 1:100 000 (ok. 1900)', 'Deutschen Reiches 1:100 000 (ok. 1900)', kdr_extent),
      addLayer('m25k', 'Messtichblätter 1:25 000 (1870-1945)', 'Messtichblätter 1:25 000 (1870-1945)', m25k_extent),
      addLayer('reymann', "Mapa Reymanna 1:200 000 (druga połowa XIX w.)", "Reymann's Special-Karte von Central Europa, 1:200 000 (druga połowa XIX w.)", reymann_extent),
      addLayer('textor', 'Mapa Textora-Sotzmanna 1:150 000 (1806-1808)', 'Mapa Textora-Sotzmanna 1:150 000 (1806-1808)', textor_extent),
      addLayer('gilly', "Mapa Gilly'ego 1:150 000 (1802-1803)", "Mapa Gilly'ego 1:150 000 (1802-1803)", gilly_extent),
      addLayer('schroetter', 'Mapa Schroettera 1:150 000 (1796-1802)', 'Mapa Schroettera 1:150 000 (1796-1802)', schroetter_extent),
    ]
  }),
  new Group({
    title: 'Mapy austriackie',
    openInLayerSwitcher: false,
    visible: false,
    permalink: "austriackie",
    infoTitle: 'Mapy austriackie',
    layerName: 'austriackie',
    layers: [
      addLayer('kummersberg', 'Mapa Kummersberga 1:115 200 (1855)', 'Mapa Kummersberga 1:115 200 (1855)', kummersberg_extent),
    ]
  }),
  new Group({
    title: 'Mapy polskie',
    openInLayerSwitcher: false,
    visible: false,
    permalink: "polskie",
    infoTitle: 'Mapy polskie',
    layerName: 'polskie',
    layers: [
      addLayer('chrzanowski', 'Karta Dawnej Polski 1:300 000 (1859)', 'Karta Dawnej Polski 1:300 000 (1859)', chrzanowski_extent),
      addLayer('TKKP_126k', 'Mapa Kwatermistrzowstwa 1:126 000 (1839-1843)', 'Mapa Kwatermistrzostwa 1:126 000 (1839-1843)', tkkp_extent),
      addLayer('gaul', 'Mapa Gaula/Raczyńskiego 1:125 000 (1807-1812)', 'Mapa Gaula/Raczyńskiego 1:125 000 (1807-1812)', gaul_extent),
    ]
  }),
  new Group({
    title: 'Mapy WIG (1919-1949)',
    openInLayerSwitcher: false,
    visible: false,
    permalink: "wig",
    infoTitle: 'Mapy WIG (1919-1949)',
    layerName: 'wig',
    layers: [
      addLayer('wig500k', 'Mapa Polski i Krajów Ościennych 1:500 000 (1947)', 'Mapa Polski i Krajów Ościennych 1:500 000 (1947)', wig500k_extent),
      addLayer('wig500k1939', 'Mapa Polski i Krajów Ościennych 1:500 000 (1939)', 'Mapa Polski i Krajów Ościennych 1:500 000 (1939)', wig500k_extent),
      addLayer('wig300k', 'Mapa operacyjna 1:300 000', 'Mapa operacyjna 1:300 000', wig300k_extent),
      addLayer('wig100k', 'Mapa taktyczna 1:100 000', 'Mapa taktyczna 1:100 000', wig100k_extent),
      addLayer('wig25k', 'Mapa szczegółowa 1:25 000', 'Mapa szczegółowa 1:25 000', wig25k_extent),
    ]
  }),
  vector,
];

